import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import TickIcon from "../assets/CcChatCheck.svg";
import BilledTo from "./BilledTo";
import "./ManageInvoice.scss";
import SubscriptionAndPricing from "./SubscriptionAndPricing";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import ReviewAndSend from "./ReviewAndSend";
const CreateInvoice = () => {
  const [step, setStep] = useState(1);
  const sendInvoice = () => {
    alert("Invoice sent!");
  };
  const Stepper = ({ step, greaterThan, content }) => {
    return (
      <div>
        <div className="flex items-center gap-1">
          {step > greaterThan ? (
            <img src={TickIcon} alt="tick-icon" height={24} width={24} />
          ) : step == greaterThan ? (
            <div className="h-[24px] w-[24px] flex-shrink-0 border-2 border-solid border-[#017C57] rounded-full" />
          ) : (
            <div className="h-[24px] w-[24px] flex-shrink-0 border-2 border-solid border-[#DEDEDE] rounded-full" />
          )}
          <hr
            className={`h-[2px] flex-1 border-0 bg-gradient-to-r ${
              step < greaterThan
                ? "from-[#DEDEDE] to-[#DEDEDE]"
                : step == greaterThan
                ? "from-[#017C57] to-[#DEDEDE]"
                : "from-[#017C57] to-[#017C57]"
            } `}
          />
        </div>
        <div className="font-semibold mt-2">{content}</div>
      </div>
    );
  };
  return (
    <div className="manage-box bg-[#f7f7f7]">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp; / &nbsp; &nbsp; Create Invoice
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Create Invoice</div>
      </div>
      <hr
        style={{
          width: "100%",
          border: "1px solid rgba(228, 228, 228, 1)",
        }}
      />
      <div className="p-4 bg-white mt-4 rounded-[16px] ">
        <div className="border border-solid border-[#dedede] p-6 rounded-[16px]">
          <div className="grid grid-cols-3 gap-4">
            <Stepper step={step} greaterThan={1} content="Billed To" />
            <Stepper
              step={step}
              greaterThan={2}
              content="Subscription & Pricing"
            />
            <Stepper step={step} greaterThan={3} content="Review & Send" />
          </div>
        </div>
        <div className="mt-12">
          {step == 1 ? (
            <BilledTo />
          ) : step == 2 ? (
            <SubscriptionAndPricing />
          ) : (
            <ReviewAndSend />
          )}
        </div>
        <div className=" h-px bg-[#DEDEDE] mb-2 mt-8" />
        <div className="flex items-center justify-between">
          <div
            className={`${
              step > 1 ? "visible" : "invisible"
            } flex items-center gap-3 text-sm text-white bg-[#017C57] font-semibold uppercase py-2 px-4 rounded-full cursor-pointer transition-colors duration-200 hover:bg-[#025e41] group`}
            onClick={() => setStep(step - 1)}
          >
            <span className="transition-all duration-200 group-hover:mr-1 flex items-center">
              <ArrowForwardOutlinedIcon className="rotate-180" />
            </span>
            <span>Previous</span>
          </div>
          {step === 3 ? (
            <button
              className="flex items-center text-sm text-white bg-[#017C57] font-semibold uppercase py-2 px-5 border-none rounded-full cursor-pointer transition-colors duration-200 hover:bg-[#025e41] group"
              onClick={() => {
                sendInvoice();
              }}
            >
              <span className="transition-all duration-200 group-hover:mr-1 flex items-center">
                <SendOutlinedIcon
                  style={{ height: "16px", rotate: "-45deg" }}
                />
              </span>
              <span>Send Invoice</span>
            </button>
          ) : (
            <div
              className="flex items-center text-sm text-white bg-[#017C57] font-semibold uppercase py-2 px-5 rounded-full cursor-pointer transition-colors duration-200 hover:bg-[#025e41] group"
              onClick={() => setStep(step + 1)}
            >
              <span>Next</span>
              <span className="ml-1 transition-all duration-200 group-hover:ml-3 flex items-center">
                <ArrowForwardOutlinedIcon />
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateInvoice;
